import { render, staticRenderFns } from "./return-to-vendor.vue?vue&type=template&id=6eb94d56&"
import script from "./return-to-vendor.vue?vue&type=script&lang=js&"
export * from "./return-to-vendor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports